import { KEYS_ESTADO_DENUNCIA } from '@/api/StaticApi';

/**
 * Clase que representa los filtros de consultas de magistrados con su lógica
 */
export default class FiltroDenuncias {
  numero: number;
  anio: number;
  apellido: string;
  estado: KEYS_ESTADO_DENUNCIA | "TODOS";
  fechaDesde: string;
  fechaHasta: string;
  
  
  constructor(numero?: number) {
    if (numero) this.numero = numero;
    this.estado = "TODOS"
    this.fechaDesde = undefined as unknown as string
    this.fechaHasta = undefined as unknown as string


  }

  toQuerystring(): string {
    let query = ''
    const queryParts: any[] = []
    if(this.numero) queryParts.push(`numero:${this.numero}`)
    if(this.anio) queryParts.push(`anio:${this.anio}`)
    if(this.apellido) queryParts.push(`apellido:${this.apellido}`)
    if(this.estado && this.estado !== 'TODOS') queryParts.push(`estado:${this.estado}`)
    if(this.fechaDesde) queryParts.push(`altaDesde:${this.fechaDesde.replaceAll('-', '')}`)
    if(this.fechaHasta) queryParts.push(`altaHasta:${this.fechaHasta.replaceAll('-', '')}`)
    query = queryParts.length === 0 ? '' :`&query=${queryParts.join()}`
    return query
  }
  
  clone({numero, anio, apellido, estado, fechaDesde, fechaHasta}): void {
    this.numero = numero
    this.anio = anio
    this.apellido = apellido
    this.estado = estado
    this.fechaDesde = fechaDesde
    this.fechaHasta = fechaHasta
  }



}
